module.exports = __webpack_public_path__ + "static/media/Burmy_gaussian2.8ef608b4.png";